import * as React from 'react';
import {
  DeleteBalanceEntryModal,
  type DeleteBalanceEntryModalUserProps,
} from 'src/AccountLedgerView/DeleteBalanceEntryModal';
import {
  DeleteReconciliationModal,
  type DeleteReconciliationModalUserProps,
} from 'src/AccountLedgerView/DeleteReconciliationModal';
import {
  ReconcileAnchorModal,
  type ReconcileAnchorModalUserProps,
} from 'src/AccountLedgerView/ReconcileAnchorModal';
import {
  RecordBalanceAnchorModal,
  type RecordBalanceAnchorModalUserProps,
} from 'src/AccountLedgerView/RecordBalanceAnchorModal';
import {
  AddRawTransactionToPaymentModal,
  type AddRawTransactionToPaymentModalUserProps,
} from 'src/AddRawTransactionToPaymentModal';
import {
  AddSnapshotModal,
  type AddSnapshotModalUserProps,
} from 'src/AddSnapshotModal';
import {
  BulkEditRawTransactionsModal,
  type BulkEditRawTransactionsModalUserProps,
} from 'src/BulkEditRawTransactionsModal/BulkEditRawTransactionsModal';
import {
  CreateCardBenefitModal,
  type CreateCardBenefitModalUserProps,
  DeleteCardBenefitModal,
  type DeleteCardBenefitModalUserProps,
  EditCardBenefitModal,
  type EditCardBenefitModalUserProps,
  GenerateBenefitCreditsModal,
  type GenerateBenefitCreditsModalUserProps,
  CreateFeePeriodModal,
  type CreateFeePeriodModalUserProps,
  EditFeePeriodModal,
  type EditFeePeriodModalUserProps,
  DeleteFeePeriodModal,
  type DeleteFeePeriodModalUserProps,
} from 'src/CardBenefitsView';
import {
  CreateCategoryModal,
  type CreateCategoryModalUserProps,
  DeleteCategoryModal,
  type DeleteCategoryModalUserProps,
} from 'src/CategoriesView';
import {
  DeletePlaidTokenModal,
  type DeletePlaidTokenModalUserProps,
  EditPlaidTokenModal,
  type EditPlaidTokenModalUserProps,
} from 'src/ConnectionsView';
import {
  ConnectPlaidModal,
  type ConnectPlaidModalUserProps,
} from 'src/ConnectPlaidModal';
import {
  CreateAccountModal,
  type CreateAccountModalUserProps,
} from 'src/CreateAccountModal';
import {
  CreateInverseRawTransactionModal,
  type CreateInverseRawTransactionModalUserProps,
} from 'src/CreateInverseRawTransactionModal';
import {
  CreateRawTransactionModal,
  type CreateRawTransactionModalUserProps,
} from 'src/CreateRawTransactionModal/CreateRawTransactionModal';
import {
  CreateTransactionForBenefitModal,
  type CreateTransactionForBenefitModalUserProps,
} from 'src/CreateTransactionForBenefitModal';
import {
  CreateTransactionModal,
  type CreateTransactionModalUserProps,
} from 'src/CreateTransactionModal';
import {
  DeleteAccountModal,
  type DeleteAccountModalUserProps,
} from 'src/DeleteAccountModal';
import {
  DeleteRawTransactionModal,
  type DeleteRawTransactionModalUserProps,
} from 'src/DeleteRawTransactionModal';
import {
  DeleteSnapshotModal,
  type DeleteSnapshotModalUserProps,
} from 'src/DeleteSnapshotModal';
import {
  ResetTransactionModal,
  type ResetTransactionModalUserProps,
} from 'src/DetailComponents/ResetTransactionModal';
import {
  EditAccountModal,
  type EditAccountModalUserProps,
} from 'src/EditAccountModal';
import {
  EditCategoryModal,
  type EditCategoryModalUserProps,
} from 'src/EditCategoryModal';
import {
  EditInvestmentAccountModal,
  type EditInvestmentAccountModalUserProps,
} from 'src/EditInvestmentAccountModal';
import {
  EditRawTransactionModal,
  type EditRawTransactionModalUserProps,
} from 'src/EditRawTransactionModal/EditRawTransactionModal';
import {
  EditSnapshotModal,
  type EditSnapshotModalUserProps,
} from 'src/EditSnapshotModal';
import {
  BulkEditTransactionsSheet,
  type BulkEditTransactionsSheetUserProps,
} from 'src/EditTransactionSheet/BulkEditTransactionsSheet';
import {
  EditTransactionSheet,
  type EditTransactionModalUserProps,
} from 'src/EditTransactionSheet/EditTransactionSheet';
import {
  CreateFieldModal,
  type CreateFieldModalUserProps,
  DeleteFieldModal,
  type DeleteFieldModalUserProps,
  EditFieldModal,
  type EditFieldModalUserProps,
} from 'src/FieldsView';
import {
  ImportTransactionsModal,
  type ImportTransactionsModalUserProps,
} from 'src/ImportTransactionsModal';
import {
  ReconcileGapModal,
  type ReconcileGapModalUserProps,
} from 'src/InvestmentAccountsView/ReconcileGapModal';
import Layer from 'src/Layer/Layer';
import {
  LinkBenefitModal,
  type LinkBenefitModalUserProps,
} from 'src/LinkBenefitModal';
import {
  ManageConnectionModal,
  type ManageConnectionModalUserProps,
} from 'src/ManageConnectionModal';
import {
  MergeTransactionsModal,
  type MergeTransactionsModalUserProps,
} from 'src/MergeTransactionsModal';
import {
  MigrateAccountTransactionsModal,
  type MigrateAccountTransactionsModalUserProps,
} from 'src/MigrateAccountTransactionsModal';
import {
  PayrollRecordModal,
  type PayrollRecordModalUserProps,
} from 'src/PayrollView/PayrollRecordModal';
import {
  SplitRawTransactionModal,
  type SplitRawTransactionModalUserProps,
} from 'src/SplitRawTransactionModal/SplitRawTransactionModal';
import {SyncModal, type SyncModalUserProps} from 'src/SyncModal';
import {
  TrackCreditModal,
  type TrackCreditModalUserProps,
  RecordLoanRepaymentModal,
  type RecordLoanRepaymentModalUserProps,
  RecordUseModal,
  type RecordUseModalUserProps,
} from 'src/TrackBalanceModals';
import {
  CreateUnitModal,
  type CreateUnitModalUserProps,
  DeleteUnitModal,
  type DeleteUnitModalUserProps,
  EditUnitModal,
  type EditUnitModalUserProps,
} from 'src/UnitsView';
import {
  UnlinkBenefitTransactionModal,
  type UnlinkBenefitTransactionModalUserProps,
} from 'src/UnlinkBenefitTransactionModal';
import {
  UpdateRawTransactionsModal,
  type UpdateRawTransactionsModalUserProps,
} from 'src/UpdateRawTransactionsModal/UpdateRawTransactionsModal';

export type SystemProps = {
  onRequestClose: () => void;
};

type ModalState<UserProps> =
  | {open: false}
  | {open: true; props: UserProps & SystemProps};

type ModalController<UserProps> = {
  state: ModalState<UserProps>;
  openModal: (props: UserProps) => void;
  closeModal: () => void;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const defaultModalController: ModalController<any> = {
  state: {open: false},
  openModal: () => {},
  closeModal: () => {},
};

const useModal = <UserProps,>(): ModalController<UserProps> => {
  const [state, setState] = React.useState<ModalState<UserProps>>({
    open: false,
  });
  return {
    state,
    openModal: (props: UserProps) => {
      const onRequestClose = () => setState({open: false});
      setState({
        open: true,
        props: {...props, onRequestClose},
      });
    },
    closeModal: () => setState({open: false}),
  };
};

type UseModals = {
  addRawTransactionToPaymentModal: ModalController<AddRawTransactionToPaymentModalUserProps>;
  addSnapshotModal: ModalController<AddSnapshotModalUserProps>;
  reconcileGapModal: ModalController<ReconcileGapModalUserProps>;
  bulkEditRawTransactionsModal: ModalController<BulkEditRawTransactionsModalUserProps>;
  bulkEditTransactionsModal: ModalController<BulkEditTransactionsSheetUserProps>;
  editSnapshotModal: ModalController<EditSnapshotModalUserProps>;
  connectPlaidModal: ModalController<ConnectPlaidModalUserProps>;
  createAccountModal: ModalController<CreateAccountModalUserProps>;
  createCardBenefitModal: ModalController<CreateCardBenefitModalUserProps>;
  deleteCardBenefitModal: ModalController<DeleteCardBenefitModalUserProps>;
  editCardBenefitModal: ModalController<EditCardBenefitModalUserProps>;
  generateBenefitCreditsModal: ModalController<GenerateBenefitCreditsModalUserProps>;
  createFeePeriodModal: ModalController<CreateFeePeriodModalUserProps>;
  editFeePeriodModal: ModalController<EditFeePeriodModalUserProps>;
  deleteFeePeriodModal: ModalController<DeleteFeePeriodModalUserProps>;
  createCategoryModal: ModalController<CreateCategoryModalUserProps>;
  createFieldModal: ModalController<CreateFieldModalUserProps>;
  createInverseRawTransactionModal: ModalController<CreateInverseRawTransactionModalUserProps>;
  trackCreditModal: ModalController<TrackCreditModalUserProps>;
  recordUseModal: ModalController<RecordUseModalUserProps>;
  recordLoanRepaymentModal: ModalController<RecordLoanRepaymentModalUserProps>;
  createRawTransactionModal: ModalController<CreateRawTransactionModalUserProps>;
  splitRawTransactionModal: ModalController<SplitRawTransactionModalUserProps>;
  createTransactionForBenefitModal: ModalController<CreateTransactionForBenefitModalUserProps>;
  createTransactionModal: ModalController<CreateTransactionModalUserProps>;
  deleteAccountModal: ModalController<DeleteAccountModalUserProps>;
  deleteCategoryModal: ModalController<DeleteCategoryModalUserProps>;
  deleteFieldModal: ModalController<DeleteFieldModalUserProps>;
  deletePlaidTokenModal: ModalController<DeletePlaidTokenModalUserProps>;
  deleteBalanceEntryModal: ModalController<DeleteBalanceEntryModalUserProps>;
  deleteRawTransactionModal: ModalController<DeleteRawTransactionModalUserProps>;
  deleteSnapshotModal: ModalController<DeleteSnapshotModalUserProps>;
  editRawTransactionModal: ModalController<EditRawTransactionModalUserProps>;
  editTransactionModal: ModalController<EditTransactionModalUserProps>;
  editAccountModal: ModalController<EditAccountModalUserProps>;
  editInvestmentAccountModal: ModalController<EditInvestmentAccountModalUserProps>;
  editCategoryModal: ModalController<EditCategoryModalUserProps>;
  editFieldModal: ModalController<EditFieldModalUserProps>;
  editPlaidTokenModal: ModalController<EditPlaidTokenModalUserProps>;
  reconcileAnchorModal: ModalController<ReconcileAnchorModalUserProps>;
  recordBalanceAnchorModal: ModalController<RecordBalanceAnchorModalUserProps>;
  resetTransactionModal: ModalController<ResetTransactionModalUserProps>;
  deleteReconciliationModal: ModalController<DeleteReconciliationModalUserProps>;
  importTransactionsModal: ModalController<ImportTransactionsModalUserProps>;
  linkBenefitModal: ModalController<LinkBenefitModalUserProps>;
  manageConnectionModal: ModalController<ManageConnectionModalUserProps>;
  mergeTransactionsModal: ModalController<MergeTransactionsModalUserProps>;
  migrateAccountTransactionsModal: ModalController<MigrateAccountTransactionsModalUserProps>;
  payrollRecordModal: ModalController<PayrollRecordModalUserProps>;
  syncModal: ModalController<SyncModalUserProps>;
  unlinkBenefitTransactionModal: ModalController<UnlinkBenefitTransactionModalUserProps>;
  updateRawTransactionsModal: ModalController<UpdateRawTransactionsModalUserProps>;
  createUnitModal: ModalController<CreateUnitModalUserProps>;
  editUnitModal: ModalController<EditUnitModalUserProps>;
  deleteUnitModal: ModalController<DeleteUnitModalUserProps>;
};

export const useModals = (): UseModals => {
  const context = React.useContext(ModalsContext);
  if (!context) {
    throw new Error('useModals must be used within a ModalsProvider');
  }
  return context;
};

const ModalsContext = React.createContext<UseModals>({
  addRawTransactionToPaymentModal: defaultModalController,
  addSnapshotModal: defaultModalController,
  reconcileGapModal: defaultModalController,
  bulkEditRawTransactionsModal: defaultModalController,
  bulkEditTransactionsModal: defaultModalController,
  editSnapshotModal: defaultModalController,
  connectPlaidModal: defaultModalController,
  createAccountModal: defaultModalController,
  createCardBenefitModal: defaultModalController,
  deleteCardBenefitModal: defaultModalController,
  editCardBenefitModal: defaultModalController,
  generateBenefitCreditsModal: defaultModalController,
  createFeePeriodModal: defaultModalController,
  editFeePeriodModal: defaultModalController,
  deleteFeePeriodModal: defaultModalController,
  createCategoryModal: defaultModalController,
  createFieldModal: defaultModalController,
  createInverseRawTransactionModal: defaultModalController,
  trackCreditModal: defaultModalController,
  recordUseModal: defaultModalController,
  recordLoanRepaymentModal: defaultModalController,
  createRawTransactionModal: defaultModalController,
  splitRawTransactionModal: defaultModalController,
  createTransactionForBenefitModal: defaultModalController,
  createTransactionModal: defaultModalController,
  deleteAccountModal: defaultModalController,
  deleteCategoryModal: defaultModalController,
  deleteFieldModal: defaultModalController,
  deletePlaidTokenModal: defaultModalController,
  deleteBalanceEntryModal: defaultModalController,
  deleteRawTransactionModal: defaultModalController,
  deleteSnapshotModal: defaultModalController,
  editRawTransactionModal: defaultModalController,
  editTransactionModal: defaultModalController,
  editAccountModal: defaultModalController,
  editInvestmentAccountModal: defaultModalController,
  editCategoryModal: defaultModalController,
  editFieldModal: defaultModalController,
  editPlaidTokenModal: defaultModalController,
  reconcileAnchorModal: defaultModalController,
  recordBalanceAnchorModal: defaultModalController,
  resetTransactionModal: defaultModalController,
  deleteReconciliationModal: defaultModalController,
  importTransactionsModal: defaultModalController,
  linkBenefitModal: defaultModalController,
  manageConnectionModal: defaultModalController,
  mergeTransactionsModal: defaultModalController,
  migrateAccountTransactionsModal: defaultModalController,
  payrollRecordModal: defaultModalController,
  syncModal: defaultModalController,
  unlinkBenefitTransactionModal: defaultModalController,
  updateRawTransactionsModal: defaultModalController,
  createUnitModal: defaultModalController,
  editUnitModal: defaultModalController,
  deleteUnitModal: defaultModalController,
});

export const ModalsProvider = ({children}: {children: React.ReactNode}) => {
  const addRawTransactionToPaymentModal =
    useModal<AddRawTransactionToPaymentModalUserProps>();
  const addSnapshotModal = useModal<AddSnapshotModalUserProps>();
  const reconcileGapModal = useModal<ReconcileGapModalUserProps>();
  const bulkEditRawTransactionsModal =
    useModal<BulkEditRawTransactionsModalUserProps>();
  const bulkEditTransactionsModal =
    useModal<BulkEditTransactionsSheetUserProps>();
  const editSnapshotModal = useModal<EditSnapshotModalUserProps>();
  const connectPlaidModal = useModal<ConnectPlaidModalUserProps>();
  const createAccountModal = useModal<CreateAccountModalUserProps>();
  const createCardBenefitModal = useModal<CreateCardBenefitModalUserProps>();
  const deleteCardBenefitModal = useModal<DeleteCardBenefitModalUserProps>();
  const editCardBenefitModal = useModal<EditCardBenefitModalUserProps>();
  const generateBenefitCreditsModal =
    useModal<GenerateBenefitCreditsModalUserProps>();
  const createFeePeriodModal = useModal<CreateFeePeriodModalUserProps>();
  const editFeePeriodModal = useModal<EditFeePeriodModalUserProps>();
  const deleteFeePeriodModal = useModal<DeleteFeePeriodModalUserProps>();
  const createCategoryModal = useModal<CreateCategoryModalUserProps>();
  const createFieldModal = useModal<CreateFieldModalUserProps>();
  const createInverseRawTransactionModal =
    useModal<CreateInverseRawTransactionModalUserProps>();
  const trackCreditModal = useModal<TrackCreditModalUserProps>();
  const recordUseModal = useModal<RecordUseModalUserProps>();
  const recordLoanRepaymentModal =
    useModal<RecordLoanRepaymentModalUserProps>();
  const createRawTransactionModal =
    useModal<CreateRawTransactionModalUserProps>();
  const splitRawTransactionModal =
    useModal<SplitRawTransactionModalUserProps>();
  const createTransactionForBenefitModal =
    useModal<CreateTransactionForBenefitModalUserProps>();
  const createTransactionModal = useModal<CreateTransactionModalUserProps>();
  const deleteAccountModal = useModal<DeleteAccountModalUserProps>();
  const deleteCategoryModal = useModal<DeleteCategoryModalUserProps>();
  const deleteFieldModal = useModal<DeleteFieldModalUserProps>();
  const deletePlaidTokenModal = useModal<DeletePlaidTokenModalUserProps>();
  const deleteBalanceEntryModal =
    useModal<DeleteBalanceEntryModalUserProps>();
  const deleteRawTransactionModal =
    useModal<DeleteRawTransactionModalUserProps>();
  const deleteSnapshotModal = useModal<DeleteSnapshotModalUserProps>();
  const editRawTransactionModal =
    useModal<EditRawTransactionModalUserProps>();
  const editTransactionModal = useModal<EditTransactionModalUserProps>();
  const editAccountModal = useModal<EditAccountModalUserProps>();
  const editInvestmentAccountModal =
    useModal<EditInvestmentAccountModalUserProps>();
  const editCategoryModal = useModal<EditCategoryModalUserProps>();
  const editFieldModal = useModal<EditFieldModalUserProps>();
  const editPlaidTokenModal = useModal<EditPlaidTokenModalUserProps>();
  const reconcileAnchorModal =
    useModal<ReconcileAnchorModalUserProps>();
  const recordBalanceAnchorModal =
    useModal<RecordBalanceAnchorModalUserProps>();
  const resetTransactionModal = useModal<ResetTransactionModalUserProps>();
  const deleteReconciliationModal =
    useModal<DeleteReconciliationModalUserProps>();
  const importTransactionsModal =
    useModal<ImportTransactionsModalUserProps>();
  const linkBenefitModal = useModal<LinkBenefitModalUserProps>();
  const manageConnectionModal = useModal<ManageConnectionModalUserProps>();
  const mergeTransactionsModal = useModal<MergeTransactionsModalUserProps>();
  const migrateAccountTransactionsModal =
    useModal<MigrateAccountTransactionsModalUserProps>();
  const payrollRecordModal = useModal<PayrollRecordModalUserProps>();
  const syncModal = useModal<SyncModalUserProps>();
  const unlinkBenefitTransactionModal =
    useModal<UnlinkBenefitTransactionModalUserProps>();
  const updateRawTransactionsModal =
    useModal<UpdateRawTransactionsModalUserProps>();
  const createUnitModal = useModal<CreateUnitModalUserProps>();
  const editUnitModal = useModal<EditUnitModalUserProps>();
  const deleteUnitModal = useModal<DeleteUnitModalUserProps>();

  const modals = {
    addRawTransactionToPaymentModal,
    addSnapshotModal,
    reconcileGapModal,
    bulkEditRawTransactionsModal,
    bulkEditTransactionsModal,
    editSnapshotModal,
    connectPlaidModal,
    createAccountModal,
    createCardBenefitModal,
    deleteCardBenefitModal,
    editCardBenefitModal,
    generateBenefitCreditsModal,
    createFeePeriodModal,
    editFeePeriodModal,
    deleteFeePeriodModal,
    createCategoryModal,
    createFieldModal,
    createInverseRawTransactionModal,
    trackCreditModal,
    recordUseModal,
    recordLoanRepaymentModal,
    createRawTransactionModal,
    splitRawTransactionModal,
    createTransactionForBenefitModal,
    createTransactionModal,
    deleteAccountModal,
    deleteCategoryModal,
    deleteFieldModal,
    deletePlaidTokenModal,
    deleteBalanceEntryModal,
    deleteRawTransactionModal,
    deleteSnapshotModal,
    editRawTransactionModal,
    editTransactionModal,
    editAccountModal,
    editInvestmentAccountModal,
    editCategoryModal,
    editFieldModal,
    editPlaidTokenModal,
    reconcileAnchorModal,
    recordBalanceAnchorModal,
    resetTransactionModal,
    deleteReconciliationModal,
    importTransactionsModal,
    linkBenefitModal,
    manageConnectionModal,
    mergeTransactionsModal,
    migrateAccountTransactionsModal,
    syncModal,
    unlinkBenefitTransactionModal,
    updateRawTransactionsModal,
    createUnitModal,
    editUnitModal,
    deleteUnitModal,
    payrollRecordModal,
  };

  return (
    <ModalsContext.Provider value={modals}>
      {children}
      <Layer>
        {addRawTransactionToPaymentModal.state.open && (
          <AddRawTransactionToPaymentModal
            {...addRawTransactionToPaymentModal.state.props}
          />
        )}
        {addSnapshotModal.state.open && (
          <AddSnapshotModal {...addSnapshotModal.state.props} />
        )}
        {reconcileGapModal.state.open && (
          <ReconcileGapModal {...reconcileGapModal.state.props} />
        )}
        {bulkEditTransactionsModal.state.open && (
          <BulkEditTransactionsSheet
            {...bulkEditTransactionsModal.state.props}
          />
        )}
        {bulkEditRawTransactionsModal.state.open && (
          <BulkEditRawTransactionsModal
            {...bulkEditRawTransactionsModal.state.props}
          />
        )}
        {editSnapshotModal.state.open && (
          <EditSnapshotModal {...editSnapshotModal.state.props} />
        )}
        {connectPlaidModal.state.open && (
          <ConnectPlaidModal {...connectPlaidModal.state.props} />
        )}
        {createAccountModal.state.open && (
          <CreateAccountModal {...createAccountModal.state.props} />
        )}
        {createCardBenefitModal.state.open && (
          <CreateCardBenefitModal {...createCardBenefitModal.state.props} />
        )}
        {editCardBenefitModal.state.open && (
          <EditCardBenefitModal {...editCardBenefitModal.state.props} />
        )}
        {deleteCardBenefitModal.state.open && (
          <DeleteCardBenefitModal {...deleteCardBenefitModal.state.props} />
        )}
        {generateBenefitCreditsModal.state.open && (
          <GenerateBenefitCreditsModal
            {...generateBenefitCreditsModal.state.props}
          />
        )}
        {createFeePeriodModal.state.open && (
          <CreateFeePeriodModal {...createFeePeriodModal.state.props} />
        )}
        {editFeePeriodModal.state.open && (
          <EditFeePeriodModal {...editFeePeriodModal.state.props} />
        )}
        {deleteFeePeriodModal.state.open && (
          <DeleteFeePeriodModal {...deleteFeePeriodModal.state.props} />
        )}
        {createCategoryModal.state.open && (
          <CreateCategoryModal {...createCategoryModal.state.props} />
        )}
        {createFieldModal.state.open && (
          <CreateFieldModal {...createFieldModal.state.props} />
        )}
        {createInverseRawTransactionModal.state.open && (
          <CreateInverseRawTransactionModal
            {...createInverseRawTransactionModal.state.props}
          />
        )}
        {trackCreditModal.state.open && (
          <TrackCreditModal {...trackCreditModal.state.props} />
        )}
        {recordUseModal.state.open && (
          <RecordUseModal {...recordUseModal.state.props} />
        )}
        {recordLoanRepaymentModal.state.open && (
          <RecordLoanRepaymentModal
            {...recordLoanRepaymentModal.state.props}
          />
        )}
        {createRawTransactionModal.state.open && (
          <CreateRawTransactionModal
            {...createRawTransactionModal.state.props}
          />
        )}
        {splitRawTransactionModal.state.open && (
          <SplitRawTransactionModal {...splitRawTransactionModal.state.props} />
        )}
        {createTransactionForBenefitModal.state.open && (
          <CreateTransactionForBenefitModal
            {...createTransactionForBenefitModal.state.props}
          />
        )}
        {createTransactionModal.state.open && (
          <CreateTransactionModal {...createTransactionModal.state.props} />
        )}
        {deleteAccountModal.state.open && (
          <DeleteAccountModal {...deleteAccountModal.state.props} />
        )}
        {deleteCategoryModal.state.open && (
          <DeleteCategoryModal {...deleteCategoryModal.state.props} />
        )}
        {deleteFieldModal.state.open && (
          <DeleteFieldModal {...deleteFieldModal.state.props} />
        )}
        {deletePlaidTokenModal.state.open && (
          <DeletePlaidTokenModal {...deletePlaidTokenModal.state.props} />
        )}
        {deleteBalanceEntryModal.state.open && (
          <DeleteBalanceEntryModal
            {...deleteBalanceEntryModal.state.props}
          />
        )}
        {deleteRawTransactionModal.state.open && (
          <DeleteRawTransactionModal
            {...deleteRawTransactionModal.state.props}
          />
        )}
        {deleteSnapshotModal.state.open && (
          <DeleteSnapshotModal {...deleteSnapshotModal.state.props} />
        )}
        {editRawTransactionModal.state.open && (
          <EditRawTransactionModal
            {...editRawTransactionModal.state.props}
          />
        )}
        {editTransactionModal.state.open && (
          <EditTransactionSheet {...editTransactionModal.state.props} />
        )}
        {editAccountModal.state.open && (
          <EditAccountModal {...editAccountModal.state.props} />
        )}
        {editInvestmentAccountModal.state.open && (
          <EditInvestmentAccountModal
            {...editInvestmentAccountModal.state.props}
          />
        )}
        {editCategoryModal.state.open && (
          <EditCategoryModal {...editCategoryModal.state.props} />
        )}
        {editFieldModal.state.open && (
          <EditFieldModal {...editFieldModal.state.props} />
        )}
        {editPlaidTokenModal.state.open && (
          <EditPlaidTokenModal {...editPlaidTokenModal.state.props} />
        )}
        {reconcileAnchorModal.state.open && (
          <ReconcileAnchorModal
            {...reconcileAnchorModal.state.props}
          />
        )}
        {recordBalanceAnchorModal.state.open && (
          <RecordBalanceAnchorModal
            {...recordBalanceAnchorModal.state.props}
          />
        )}
        {resetTransactionModal.state.open && (
          <ResetTransactionModal {...resetTransactionModal.state.props} />
        )}
        {deleteReconciliationModal.state.open && (
          <DeleteReconciliationModal
            {...deleteReconciliationModal.state.props}
          />
        )}
        {importTransactionsModal.state.open && (
          <ImportTransactionsModal {...importTransactionsModal.state.props} />
        )}
        {linkBenefitModal.state.open && (
          <LinkBenefitModal {...linkBenefitModal.state.props} />
        )}
        {mergeTransactionsModal.state.open && (
          <MergeTransactionsModal {...mergeTransactionsModal.state.props} />
        )}
        {manageConnectionModal.state.open && (
          <ManageConnectionModal {...manageConnectionModal.state.props} />
        )}
        {migrateAccountTransactionsModal.state.open && (
          <MigrateAccountTransactionsModal
            {...migrateAccountTransactionsModal.state.props}
          />
        )}
        {syncModal.state.open && <SyncModal {...syncModal.state.props} />}
        {unlinkBenefitTransactionModal.state.open && (
          <UnlinkBenefitTransactionModal
            {...unlinkBenefitTransactionModal.state.props}
          />
        )}
        {updateRawTransactionsModal.state.open && (
          <UpdateRawTransactionsModal
            {...updateRawTransactionsModal.state.props}
          />
        )}
        {createUnitModal.state.open && (
          <CreateUnitModal {...createUnitModal.state.props} />
        )}
        {editUnitModal.state.open && (
          <EditUnitModal {...editUnitModal.state.props} />
        )}
        {deleteUnitModal.state.open && (
          <DeleteUnitModal {...deleteUnitModal.state.props} />
        )}
        {payrollRecordModal.state.open && (
          <PayrollRecordModal {...payrollRecordModal.state.props} />
        )}
      </Layer>
    </ModalsContext.Provider>
  );
};
